<template>
    <div>
        <div class="form">
            <section class="form-section">
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <form-input
                            name="title"
                            disabled
                            :value="course.title"
                        >
                            {{ trans('courses.label.title') }}
                        </form-input>
                    </div>

                    <div class="form-row__col form-row__col--one-half">
                        <label class="label" for="variation">{{ trans('course_variations.label.variation_name') }}</label>

                        <v-select v-model="selectedVariation"
                            :options="variations"
                            class="form-vue-select"
                            @input="changedVariation"
                        >
                            <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                        </v-select>

                        <input name="variation" v-model="selectedVariation.value" hidden>
                    </div>
                </div>
            </section>

            <div v-if="showMatchingForm">
                <section class="form-section" v-for="(learning_content,index) in oldLearningContents" :key="index">
                    <div class="h:margin-bottom-2">
                        <label class="form-section-heading">
                            {{ trans('learning_contents.change_lc.headline', {name: learning_content.label}) }}
                        </label>
                    </div>
                    <div class="form-row">
                        <div class="form-row__col form-row__col--one-half">
                            <label class="label" for="variation">{{ trans('learning_contents.change_lc.label.newlc') }}</label>

                            <v-select v-model="selectedNewLc[index]"
                                :options="newLearningContents"
                                :clearable="false"
                                class="form-vue-select"
                            >
                                <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                            </v-select>

                            <input :name="'lcChange[' + index + '][oldlc]'" :value="learning_content.value" hidden>
                            <input :name="'lcChange[' + index + '][newlc]'" v-model="selectedNewLc[index].value" hidden>
                        </div>
                    </div>
                </section>
            </div>

            <section class="form-section" v-if="showConfirmCheckbox">
                <div class="form-row">
                    <div class="form-row__col">
                        <checkbox v-model="confirmCheckbox">
                            {{trans('learning_contents.change_lc.label.confirm')}}
                        </checkbox>
                    </div>
                </div>
            </section>
        </div>

        <div class="page-control">
            <div class="page-control__element">
                <a
                    :href="backUrl"
                    class="btn btn--big btn--tertiary">
                        {{ trans('buttons.back') }}
                </a>
            </div>
            <div class="page-control__element">
                <button :disabled="disableSubmitButton" type="submit" class="btn btn--big btn--primary">{{ trans('buttons.submit') }}</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: [
        'course',
        'variations',
        'currentVariation',
        'backUrl',
    ],

    data() {
        return {
            selectedVariation: this.currentVariation,
            oldLearningContents: [],
            newLearningContents: [],
            selectedNewLc: [],
            confirmCheckbox: false,
        };
    },

    computed: {
        showMatchingForm() {
            return !!this.oldLearningContents.length;
        },
        showConfirmCheckbox() {
            if (!this.oldLearningContents.length) {
                return false;
            }
            return !this.selectedNewLc.every((item) => item.value);
        },
        disableSubmitButton() {
            return this.showConfirmCheckbox && !this.confirmCheckbox;
        },
    },

    methods: {
        changedVariation() {
            if (this.selectedVariation.value != this.currentVariation.value) {
                var url = this.route('mainapi.courses.variations.get-lc-for-cv-change', this.course.id);
                var postObject = {'oldcv': this.currentVariation.value, 'newcv': this.selectedVariation.value};
                axios.post(url, postObject)
                .then((data) => {
                    this.oldLearningContents = data.data.oldcv;
                    this.newLearningContents = data.data.newcv;

                    this.newLearningContents.unshift({'label': this.trans('learning_contents.change_lc.delete_progresses'), 'value': 0});
                    for (var i = 0; i < this.oldLearningContents.length; i++) {
                        this.selectedNewLc[i] = {'label': this.trans('learning_contents.change_lc.delete_progresses'), 'value': 0};
                    }
                });
            } else {
                this.oldLearningContents = [];
                this.newLearningContents = [];
            }
        },
    },
};
</script>
